import {
  NOTIFICATION_TEMPLATES_LOADING,
  NOTIFICATION_TEMPLATES_ERROR,

  NOTIFICATION_TEMPLATES_GET_LIST,
  NOTIFICATION_TEMPLATES_CREATE,
  NOTIFICATION_TEMPLATES_DELETE
} from "actions/notificationTemplates/constants";

const initialState = {
  loading: false,
  errors: [],

  list: [],
};

export default function (state = initialState, action) {
  let list = [],
    index;
  switch (action.type) {
    case NOTIFICATION_TEMPLATES_LOADING:
      return {
        ...state,
        loading: action.payload.content
      };
    case NOTIFICATION_TEMPLATES_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload.content
      };
    case NOTIFICATION_TEMPLATES_GET_LIST:
      return {
        ...state,
        errors: [],
        loading: false,
        list: action.payload.content,
      };
    case NOTIFICATION_TEMPLATES_CREATE:
      list = Object.assign([], state.list);
      if (action.payload.create) {
        list.push(action.payload.data);
      } else {
        index = list.findIndex(item => item.id === action.payload.data.id);
        if (index > -1) {
          list[index] = action.payload.data;
        }
      }

      return {
        ...state,
        errors: [],
        loading: false,
        list
      };
    case NOTIFICATION_TEMPLATES_DELETE:
      list = Object.assign([], state.list);
      index = list.findIndex(item => item.id === action.payload);
      if (index > -1) {
        list.splice(index, 1);
      }
      return {
        ...state,
        errors: [],
        loading: false,
        list
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/notificationTemplatesReducer.js